import React, { useState } from 'react';
import styled from 'styled-components';

const SHOW_FIRST = 3;

const TextButton = styled.span`
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    text-decoration: none;
  }
`;

export default function PhoneNumber({ number, onClick }) {
  const len = number.length;

  if (!len || len < 3) {
    return null;
  }

  const [showingFullNumber, changeShowingFullNumber] = useState(false);
  const truncatedNumber =
    number.substr(0, SHOW_FIRST) +
    Array.apply(null, Array(len - SHOW_FIRST))
      .map(() => '×')
      .join('');
  if (!showingFullNumber) {
    return (
      <span>
        {truncatedNumber}{' '}
        <TextButton
          role="button"
          tabIndex="0"
          onClick={() => {
            onClick();
            changeShowingFullNumber(true);
          }}
        >
          Show
        </TextButton>
      </span>
    );
  }
  return <span>{number}</span>;
}
